import { createFileRoute } from "@tanstack/react-router"
import { useEffect } from "react"
import { useAuthSession } from "~/hooks/useAuthSession"

const SignoutPage = () => {
  const { signOut } = useAuthSession()

  useEffect(() => {
    void signOut({ callbackUrl: "/" })
  }, [signOut])

  return <></>
}

export const Route = createFileRoute("/signout")({
  component: SignoutPage,
})

/**
 *
 *
 *
 * signIn(providers.email?.id, values);
 *
 *
 *     <Button
              variant="outline"
              type="button"
              className="mb-2 w-full"
              onClick={async () => await signIn(providers.twitter?.id)}
            >
              <Facebook className="mr-1" />
              Sign in with Twitter
            </Button>
 *
 *
 *
 *
 */
